import React from 'react';
import _ from 'lodash';
import { InputText } from 'primereact/inputtext';
import { withFormikFormControl } from '../FormikFormControl';
import { FormPageFieldComponentProps } from 'types/formPage';
import {wrapComponent, extract} from "../utils";
import BaseInput from "./BaseFields/BaseInput";

export const Url = (props: FormPageFieldComponentProps) => {
  const strict = _.get(props, 'extraConfig.strict', true)
  return <BaseInput {...props} type={strict ? "url" : "text"}/>
  // const comp = <InputText {...extract({}, extraConfig, restProps)} type={strict ? 'url' : 'text'}/>;
  // return wrapComponent(comp, extraConfig)
};

export const UrlFormik = withFormikFormControl({ })(Url);

export default UrlFormik;
